<template>
  <section class="section">
    <div class="row mb-2">
        <!--<div class="col">
          <v-select :clearable="false"
        :options="modelOptions"
        :reduce="item => item.id"
        label="name"
        value="id"
        placeholder="Cerca per modello"
        v-model="currentDataModelId" />
        </div>-->
        <div class="col">
          <input v-if="rows && rows.length > 0" type="text" class="form-control" placeholder="Cerca..."
            v-model="filterVirtual" @input="filterList" />
        </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="d-flex justify-content-between mb-4">
          <div class="d-flex align-items-center">
            <span>Dal</span>
            <vue-monthly-picker class="text-capitalize mx-2" v-model="fromMonth" :monthLabels="monthLabels"
              :dateFormat="'MMMM/YYYY'" :clearOption="false" @selected="loadCorrections" />
            <span>al</span>
            <vue-monthly-picker class="text-capitalize mx-2" v-model="toMonth" :monthLabels="monthLabels"
              :dateFormat="'MMMM/YYYY'" :clearOption="false" @selected="loadCorrections" />
          </div>
          <b-btn variant="warning" @click="$bvModal.show('correctionVirtualModal')">Calcola correzione utenze</b-btn>
        </div>

        <b-alert :show="filteredRows && filteredRows.length == 0 && rows && rows.length > 0">
          Nessuna utenza trovata con "{{ filterVirtual }}".
        </b-alert>
        <b-alert :show="rows && rows.length == 0">
          Nessuna correzione presente.
        </b-alert>
        <div class="overflow-auto">
          <table v-if="filteredRows && filteredRows.length > 0" class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Utenza</th>
                <th scope="col" v-for="(item, index) in period" :key="index">
                  <span class="text-capitalize">{{ formatDate(item) }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filteredRows" :key="index">
                <td>{{ item.name }}</td>
                <td v-for="(value, idx) in item.values" :key="idx">
                  <span v-if="!value.value">-</span>
                  <span v-else>{{ formatPrecision(value.value, 4) }}</span>
                  <br>
                  <strong>
                    <span v-if="!value.correctedValue">-</span>
                    <span v-else>{{ formatPrecision(value.correctedValue, 4) }}</span>
                  </strong>
                  <br>
                  <span v-if="value.value"
                    :class="value.percentage > 0 ? 'color-green' : '' || value.percentage < 0 ? 'color-red' : ''">
                    {{ formatPercentage(value.percentage) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal id="correctionVirtualModal" ref="correctionVirtualModal" centered title="Calcola correzione utenze"
      header-bg-variant="warning" ok-title="Calcola" ok-variant="primary" @ok="calculateCorrections()">
      <b-row>
        <b-col>
          <label class="form-label">Vettore</label>
          <b-form-select class="form-control" v-model="vector" :options="vectorOptions" />
        </b-col>
      </b-row>
      <label class="form-label mt-2">Mese</label>
      <b-row>
        <b-col style="display: grid">
          <label class="form-label">dal</label>
          <vue-monthly-picker v-model="fromMonthCorrection" :monthLabels="monthLabels" :dateFormat="'MMMM/YYYY'"
            :clearOption="false" />
        </b-col>
        <b-col style="display: grid">
          <label class="form-label">al</label>
          <vue-monthly-picker v-model="toMonthCorrection" :monthLabels="monthLabels" :dateFormat="'MMMM/YYYY'"
            :clearOption="false" />
        </b-col>
      </b-row>

    </b-modal>
  </section>
</template>

<script>
import api from '@/services/api';
import PageMixin from "../../Charts/PageMixin";
import moment from 'moment';
import utils from "../../../utilsMixin";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: "VirtualCorrections",
  mixins: [PageMixin, utils],
  components: { vSelect },
  data() {
    return {
      currentDataModelId: 1,
      modelOptions: [],
      rows: [],
      filteredRows: [],
      vector: "EE",
      fromMonth: moment().subtract(1, 'months').format(),
      toMonth: moment().format(),
      period: [],
      fromMonthCorrection: moment().subtract(1, 'months').format(),
      toMonthCorrection: moment().format(),
      filterVirtual: null
    }
  },
  props: ['siteId'],
  computed: {
    virtualChannels() {
      return this.$store.state.sites.current.channels.filter(item => item.is_virtual == 1);
    },
    vectorOptions() {
      let vectors = _.cloneDeep(this.$store.state.vectors.list);

      return vectors.map(v => {
        return { text: v.name, value: v.code };
      })
    },
  },
  async created() {
    this.$store.commit("loading");
    this.$store.dispatch('sites/dataModels', this.customerGuid).then(async (models) => {
      if (Array.isArray(models)) {
        this.allModelOptions = models;
        this.modelOptions = models.filter(item => {
          if (item.sites.length > 0) {
            return !!item.sites.find(site => site.id == this.siteId);
          }
        });
      }
      if (this.modelOptions.length > 0) {
        this.currentDataModelId = this.modelOptions[0].id;
      }
      await this.loadCorrections();
      this.$store.commit("stopLoading");
    });

  },
  methods: {
    filterList() {
      if (!this.filterVirtual) {
        this.filteredRows = [...this.rows];
      } else {
        const filter = this.filterVirtual.toLowerCase();

        this.filteredRows = this.rows.filter(item => {
          if (item.name.toLowerCase().indexOf(filter) > -1) {
            return true;
          }
          if (item.channel_code.toLowerCase().indexOf(filter) > -1) {
            return true;
          }
          return false;
        })
      }
    },
    formatPercentage(perc) {
      const value = perc * 100;

      if (value > 0) {
        return "+" + this.formatPrecision(value, 4) + "%";
      }
      return this.formatPrecision(value, 4) + "%";
    },
    formatDate(date) {
      return moment(date, "MM-yyyy").format("MMM YY");
    },
    async calculateCorrections() {
      this.$store.commit("loading");
      try {
        const data = {
          vector: this.vector,
          fromMonth: moment(this.fromMonthCorrection).format("MM-yyyy"),
          toMonth: moment(this.toMonthCorrection).format("MM-yyyy"),
          siteId: this.siteId
        }

        const response = await api().post("/customer/correct-virtual", data);
        if (response.data.code == 1) {
          this.$notify({
            type: "success",
            text: "Correzioni calcolate con successo",
            title: "Successo",
          });
        } else {
          this.$notify({
            type: "error",
            text: response.data.message,
            title: 'Errore',
          });
        }

        await this.loadCorrections();
        this.$store.commit("stopLoading");
      } catch (e) {
        console.log(e)
        this.$notify({
          type: "error",
          text: e.message,
          title: 'Errore',
        });
        this.$store.commit("stopLoading");
      }
    },
    async loadCorrections() {
      this.$store.commit("loading");
      //try {
        if (moment(this.fromMonth).diff(moment(this.toMonth)) > 0) {
          this.$notify({
            type: "warn",
            text: "La data di inizio deve essere precedente a quella di fine",
            title: 'Attenzione'
          });

          this.$store.commit("stopLoading");
          return;
        }

        const fromMonth = moment(this.fromMonth).format("MM-yyyy");
        const toMonth = moment(this.toMonth).format("MM-yyyy");

        const differenceMonth = moment(this.toMonth).diff(moment(this.fromMonth), 'months') + 1;

        const response = await api().get(`/customer/site/${this.$route.params.guid}/virtual/correction/${fromMonth}/${toMonth}`);
        let data = response.data.data;
        this.period = [];
        this.rows = [];

        data.map(item => {
          const channel = this.virtualChannels.find(virtual => virtual.code == item.channel_code && virtual.data_model_id == this.currentDataModelId);
          if (!channel) {
            return
          }
          const name = channel.name;
          const channel_code = channel.code;

          if (!this.period.includes(item.month + "-" + item.year)) {
            this.period.push(item.month + "-" + item.year);
          }

          let isNew = true;

          this.rows = this.rows.map(row => {
            if (row.name == name && row.values.length < differenceMonth) {
              row.values.push({ value: item.value, correctedValue: item.correctedValue, percentage: item.factor });
              isNew = false;
            }
            return row;
          })

          if (isNew) {
            this.rows.push({ name: name, channel_code: channel_code, values: [{ value: item.value, correctedValue: item.correctedValue, percentage: item.factor }] });
          }
        })

        this.rows = this.rows.sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          return -1;
        });

        console.log(this.rows)

        this.filteredRows = [...this.rows];

        this.$store.commit("stopLoading");
/*      } catch (e) {
        console.log(e)
        this.$notify({
          type: "error",
          text: e.message,
          title: 'Errore',
        });

        this.$store.commit("stopLoading");
      }*/
    },
  },
}
</script>

<style scoped>
.color-green {
  color: green;
}

.color-red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Sites/VirtualCorrections.vue